<template>
    <div class="awoods-comment-editor" v-show="owner.mainComponent?.isCommentingAllowed() == true">
        <div class="awoods-cancel-reply" title="取消回复" default-text="取消回复"
            v-show="isReplying" 
            v-on:click="$emit('cancel-reply')"
        >
            取消回复
        </div>

        <div class="awoods-commenter-info" v-show="!hasLoggedIn()">
            <input name="nick" type="text" class="awoods-input"
                v-bind:placeholder="owner.lang.nick" 
                v-model="formData_nick"
            >
            <div class="awoods-commenter-avatar-preview"><img v-show="avatarPreviewing!=''" v-bind:src="getMail()"></div>
            <input name="mail" type="email" class="awoods-input" 
                v-bind:placeholder="owner.lang.mail" 
                v-if="mailRequired" 
                v-model="formData_mail"
                v-on:input="onMailInput"
            >
            <input name="website" type="text" class="awoods-input" 
                v-bind:placeholder="owner.lang.website" 
                v-if="websiteRequired" 
                v-model="formData_website"
            >
        </div>
        
        <div style="position: relative">
            <textarea id="awoods-input" ref="inputText"
                class="awoods-input" 
                v-bind:placeholder="owner.lang.comment_tips" 
                v-bind:default-placeholder="owner.lang.comment_tips" 
                v-bind:disabled="showSubmitingAnimation"
                v-bind:style="showSubmitingAnimation?'background-color: #f5f5f5;':''"
                v-model="formData_content"
            ></textarea>

            <div class="awoods-toolbar">
                <div class="awoods-toolbar-left">
                    <div class="awoods-button awoods-button-smilieset" title="表情"
                        v-show="(owner.opt.smilies?.length ?? 0) > 0"
                        v-on:click="onSmilieButtonClick"
                    >
                        <svg style="margin-right: 4px;"t="1713243221090" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="20"><path d="M336 421m-48 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0Z" p-id="1436"></path><path d="M688 421m-48 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0Z" p-id="1437"></path><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m263 711c-34.2 34.2-74 61-118.3 79.8C611 874.2 562.3 884 512 884c-50.3 0-99-9.8-144.8-29.2-44.3-18.7-84.1-45.6-118.3-79.8-34.2-34.2-61-74-79.8-118.3C149.8 611 140 562.3 140 512s9.8-99 29.2-144.8c18.7-44.3 45.6-84.1 79.8-118.3 34.2-34.2 74-61 118.3-79.8C413 149.8 461.7 140 512 140c50.3 0 99 9.8 144.8 29.2 44.3 18.7 84.1 45.6 118.3 79.8 34.2 34.2 61 74 79.8 118.3C874.2 413 884 461.7 884 512s-9.8 99-29.2 144.8c-18.7 44.3-45.6 84.1-79.8 118.2z" p-id="1438"></path><path d="M664 533h-48.1c-4.2 0-7.8 3.2-8.1 7.4C604 589.9 562.5 629 512 629s-92.1-39.1-95.8-88.6c-0.3-4.2-3.9-7.4-8.1-7.4H360c-4.6 0-8.2 3.8-8 8.4 4.4 84.3 74.5 151.6 160 151.6s155.6-67.3 160-151.6c0.2-4.6-3.4-8.4-8-8.4z" p-id="1439"></path></svg>
                        表情
                    </div>

                    <div class="awoods-button awoods-button-smilieset"
                        v-on:click="onImageButtonClick"
                    >
                        <input type="file" id="upload-image" 
                            accept="image/jpeg, image/png" 
                            style="display: none;" 
                            ref="uploadImage" 
                            v-on:change="onUploadChange"
                        />
                        上传图片
                    </div>
                    
                    <div class="awoods-button awoods-button-preview" title="预览" 
                        v-on:click="previewVisible = !previewVisible"
                        v-show="formData_content != ''"
                    >
                        <svg style="margin-right: 4px;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="20"><path d="M502.390154 935.384615a29.538462 29.538462 0 1 1 0 59.076923H141.430154C79.911385 994.461538 29.538462 946.254769 29.538462 886.153846V137.846154C29.538462 77.745231 79.950769 29.538462 141.390769 29.538462h741.218462c61.44 0 111.852308 48.206769 111.852307 108.307692v300.268308a29.538462 29.538462 0 1 1-59.076923 0V137.846154c0-26.899692-23.355077-49.230769-52.775384-49.230769H141.390769c-29.420308 0-52.775385 22.331077-52.775384 49.230769v748.307692c0 26.899692 23.355077 49.230769 52.775384 49.230769h360.999385z" p-id="17689"></path><path d="M196.923077 216.615385m29.538461 0l374.153847 0q29.538462 0 29.538461 29.538461l0 0q0 29.538462-29.538461 29.538462l-374.153847 0q-29.538462 0-29.538461-29.538462l0 0q0-29.538462 29.538461-29.538461Z" p-id="17690"></path><path d="M649.846154 846.769231a216.615385 216.615385 0 1 0 0-433.230769 216.615385 216.615385 0 0 0 0 433.230769z m0 59.076923a275.692308 275.692308 0 1 1 0-551.384616 275.692308 275.692308 0 0 1 0 551.384616z" p-id="17691"></path><path d="M807.398383 829.479768m20.886847-20.886846l0 0q20.886846-20.886846 41.773692 0l125.321079 125.321079q20.886846 20.886846 0 41.773693l0 0q-20.886846 20.886846-41.773693 0l-125.321078-125.321079q-20.886846-20.886846 0-41.773693Z" p-id="17692"></path></svg>
                        预览
                    </div>

                    <profile ref="profile" v-bind:owner="owner"></profile>

                    <div class="awoods-button awoods-button-login" title="登录" 
                        v-show="owner.opt.standalone_login_button && !hasLoggedIn()" 
                        v-on:click.prevent="onLoginButton"
                    >
                        <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="20"><path d="M512 490.496c-115.512889 0-209.514667-93.959111-209.514667-209.443556 0-115.484444 93.987556-209.436444 209.514667-209.436444s209.514667 93.952 209.514667 209.436444C721.514667 396.536889 627.52 490.496 512 490.496L512 490.496zM512 120.547556c-88.540444 0-160.576 72-160.576 160.504889 0 88.512 72.035556 160.512 160.576 160.512 88.547556 0 160.583111-72 160.583111-160.512C672.583111 192.547556 600.547556 120.547556 512 120.547556L512 120.547556zM512 120.547556M512 952.391111c-174.791111 0-351.182222-49.400889-351.182222-159.751111 0-193.585778 157.532444-351.075556 351.182222-351.075556 193.649778 0 351.189333 157.489778 351.189333 351.075556C863.182222 902.990222 686.798222 952.391111 512 952.391111L512 952.391111zM512 490.496c-166.656 0-302.250667 135.537778-302.250667 302.144 0 62.144 132.771556 110.819556 302.250667 110.819556 169.486222 0 302.257778-48.668444 302.257778-110.819556C814.250667 626.033778 678.663111 490.496 512 490.496L512 490.496zM512 490.496" fill="#272636" p-id="26719"></path></svg>
                        登录
                    </div>
                </div>

                <div class="awoods-toolbar-right">
                    <div class="awoods-button awoods-button-comment" v-on:click.left="onComment">
                        <!-- 加载动画 -->
                        <div class="awoods-submiting-indicator" v-show="showSubmitingAnimation"></div>
                        <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="20"><path d="M512 128c-212.078933 0-384 150.3488-384 335.816533 0 100.0064 50.048 189.7472 129.3696 251.264a41.6 41.6 0 0 1 7.739733 21.213867c0.942933 12.074667 1.425067 26.4448 1.8944 40.337067 0.686933 20.420267 1.399467 41.531733 3.6352 58.5216 1.851733 14.071467 6.7712 51.464533 40.567467 59.413333 4.1344 0.9728 8.2304 1.437867 12.322133 1.437867 27.720533 0 55.104-21.256533 91.217067-49.297067 17.109333-13.277867 34.798933-27.016533 50.888533-36.8384 19.336533-11.810133 42.862933-10.372267 42.952534-10.389333v-0.021334c1.1264 0.1024 2.257067 0.174933 3.409066 0.174934 212.078933 0 384-150.3488 384-335.816534C896 278.3488 724.078933 128 512 128z m0.452267 628.9664a45.312 45.312 0 0 0-3.554134-0.1664c-0.695467-0.017067-1.621333-0.034133-2.756266-0.034133-13.230933 0-38.971733 2.167467-62.7456 16.686933-18.0864 11.042133-36.701867 25.489067-54.702934 39.4624C363.037867 832.827733 336.6272 853.333333 323.528533 853.333333c-0.8576 0-1.6768-0.098133-2.5728-0.3072-1.514667-0.3584-5.376-3.362133-8.017066-23.4368-1.962667-14.929067-2.641067-34.9824-3.2896-54.378666-0.490667-14.459733-0.9856-29.2608-2.001067-42.24a84.010667 84.010667 0 0 0-15.816533-43.0464 42.594133 42.594133 0 0 0-8.311467-8.558934C211.797333 625.7408 170.666667 546.449067 170.666667 463.816533 170.666667 302.173867 323.7888 170.666667 512 170.666667s341.333333 131.5072 341.333333 293.149866c0 161.518933-152.874667 292.9408-340.881066 293.149867z" fill="" p-id="25721"></path></svg>
                        发送
                    </div>
                </div>
            </div>
        </div>
        
        <div class="awoods-panels">
            <div class="awoods-preview-panel" v-if="previewVisible && formData_content">
                <div>预览</div>
                <div class="awoods-markdown" v-html="formData_content? parseMarkdown(formData_content):''"></div>
            </div>
        </div>

        <smilies-comment
            ref="smiliesComponet"
            v-show="smiliesVisible"
            v-bind:owner="owner"
            v-on:close="onCloseSmiliePanel"
        ></smilies-comment>

        <div class="awoods-alert-info" v-show="alertMessage.text!=''">
            <div class="awoods-h">
                <div class="awoods-text" v-html="alertMessage.text"></div>
                <div class="awoods-alert-ops">
                    <button type="button" class="awoods-button" v-on:click="cbButton1">{{alertMessage.button}}</button>
                    <button type="button" class="awoods-button" v-show="alertMessage.button2!=''" v-on:click="cbButton2">{{alertMessage.button2}}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'
import smiliesComponet from './SmilieBox.vue'
import profile from './Profile.vue'
import md2html from '../utils/Markdown2Html'
import Awoods from '../index'
import type CommentingModel from '../data/CommentingModel'
import { getAvatarByMail } from '../utils/Utils'
import inserfunc from '../utils/jq-insert.js'
import $ from 'jquery'
import md5 from 'md5'

export default defineComponent({
    name: 'comment-editor',
    mounted: function() {
        inserfunc()

        this.smiliesComponet = this.$refs.smiliesComponet

        let stateinfo = (this.owner as Awoods).stateData
        this.formData_nick = stateinfo.object.nick
        this.formData_website = stateinfo.object.website
        this.formData_mail = stateinfo.object.mail

        if (stateinfo.object.mail)
            this.avatarPreviewing = md5(stateinfo.object.mail)
    },
    data: () => ({
        smiliesComponet: null,
        formData_nick: '',
        formData_mail: '',
        formData_website: '',
        formData_content: '',
        alertMessage: {
            text: '',
            button: '好的',
            button2: '',
            cb_button1: null,
            cb_button2: null,
        },
        showSubmitingAnimation: false, // 正在提交评论的动画
        previewVisible: false, // 显示预览面板
        smiliesVisible: false, // 显示标签面板
        avatarPreviewing: '' // 头像预览
    }),
    methods: {
        parseMarkdown: function (text: string) {
            return md2html(this.owner.smilieManager.renderAsHtml(text))
        },
        onComment: function () {
            if(!this.checkForm())
                return

            let stateinfo = (this.owner as Awoods).stateData
            stateinfo.object.nick = this.formData_nick
            stateinfo.object.mail = this.formData_mail
            stateinfo.object.website = this.formData_website
            stateinfo.write()

            // 防止重复提交评论
            if(this.showSubmitingAnimation) {
                this.showAlert('评论正在提交，请等待')
                return
            }

            this.owner.submit({
                nick: this.formData_nick,
                mail: this.formData_mail,
                website: this.formData_website,
                content: this.formData_content,
            } as CommentingModel).then(() => {
                this.showSubmitingAnimation = false
                this.smiliesVisible = false
                this.owner.refresh()
            }).catch(() => {
                this.showSubmitingAnimation = false
                this.smiliesVisible = false
            })

            this.showSubmitingAnimation = true
        },
        onLoginButton: function() {
            this.$refs.profile.onClick()
        },
        hasLoggedIn() {
            return this.$refs?.profile?.isLoggedIn() ?? false
        },
        checkForm: function() {
            if (!this.formData_content)  {
                this.showAlert('写点儿什么吧')
                return false
            }

            if(!this.hasLoggedIn())
            {
                if (!this.formData_nick) {
                    this.showAlert('如何称呼您呢?')
                    return false
                }

                if (this.formData_mail && this.mail_required) {
                    let reg = new RegExp('^\\w+([-+.]\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*$', 'g')
                    if (!this.formData_mail.match(reg)) {
                        this.showAlert('邮箱请使用xx@xx.xx格式')
                        return false
                    }
                }

                if (this.formData_website && this.website_required) {
                    let reg = new RegExp('^https?://', 'g')
                    if (!this.formData_website.match(reg))
                    {
                        this.showAlert('网站格式请使用http(s)://开头')
                        return false
                    }
                }
            }

            return true
        },
        onSmilieButtonClick: function() {
            if(this.smiliesVisible) {
                this.smiliesVisible = false
            } else {
                this.smiliesVisible = true
            }
        },
        onImageButtonClick: function() {
            this.$refs.uploadImage.click()
        },
        onCloseSmiliePanel: function() {
            this.onSmilieButtonClick()
        },
        onUploadChange: async function(e: Event) {
            const that = this
            const files = (e.target as any).files as any[];

            if (files.length > 0)
            {
                console.log(files);

                for (const file of files) {
                    await upload(file);
                }
                
                (e.target as any).value = ''
            }

            async function upload(file: any) {
                const formData = new FormData();
                formData.append('file', file)

                try {
                    const rsp = await fetch('https://asforest.cn:3303/api/v1/upload', {
                        method: 'POST',
                        body: formData
                    })

                    const json = await rsp.json()
                    const mkLink = json.data.links.markdown

                    const inputText = that.$refs.inputText

                    var cursor = inputText.selectionStart;
                    var before = inputText.value.substring(0, cursor);
                    var after = inputText.value.substring(cursor);

                    const textToInsert = (before != '' ? '\n\n' : '') + mkLink + (after != '' ? '\n\n' : '')
                    that.formData_content = before + textToInsert + after;
                    inputText.selectionStart = inputText.selectionEnd = cursor + textToInsert.length;

                    that.previewVisible = true
                } catch (e) {
                    console.error(e)
                    alert('图片上传失败: ' + e)
                }
            }
            
        },
        onMailInput: function(e: Event) {
            let mailReg = new RegExp('^\\w+([-+.]\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*$', 'g')
            let text = $(e.target as any).val() as string
            if(text.match(mailReg))
            {
                let mailInMd5 = md5(text)
                this.avatarPreviewing = mailInMd5
            } else {
                this.avatarPreviewing = ''
            }
        },
        getMail: function() {
            return getAvatarByMail(this.owner.opt, this.avatarPreviewing)
        },
        hideAlert: function () {
            this.alertMessage.text = ''
        },
        showAlert: function (message: string, button='OK') {
            this.alertMessage.text = message
        },
        cbButton1: function() {
            if(this.alertMessage.cb_button1)
                this.alertMessage.cb_button1()
            this.hideAlert()
        },
        cbButton2: function() {
            if(this.alertMessage.cb_button2)
                this.alertMessage.cb_button2()
            this.hideAlert()

            this.alertMessage.cb_button2 = null
            this.alertMessage.button2 = ''
        }
    },
    watch: {
        smiliesVisible: function(newV: boolean, oldV: boolean) {
            if(newV) this.previewVisible = newV
        },

    },
    props: {
        owner: {
            type: Object as PropType<Awoods>,
            required: true
        },
        isReplying: {
            type: Boolean,
            required: true
        },
        mailRequired: {
            type: Boolean,
            required: true
        },
        websiteRequired: {
            type: Boolean,
            required: true
        }
    },
    components: {
        'smilies-comment': smiliesComponet,
        'profile': profile
    }
})
</script>


<style lang="stylus">
    @import "../index.styl";

    .awoods-comment-editor
        color: var(--body-text-color)
        // border-bottom: 1px solid #f0f0f0;
        // border-radius: 4px;
        margin-bottom: 10px;
        // overflow: hidden;
        position: relative;
        padding: 0px 10px;

        .awoods-input
            @extend $awoods-text;

            border: none;
            resize: none;
            outline: none;
            padding: 5px 5px;
            max-width: 100%;
            font-size: .875em;
            border-radius: 0px;

        .awoods-button
            @extend $awoods-button;
            padding: 4px 8px; 
            display: inline-flex;

        .awoods-cancel-reply
            @extend $awoods-button;
            margin-bottom: 4px
            width: 100%;
            background-color: #edededd9

        .awoods-commenter-info
            display: flex;
            flex-wrap: wrap;
            line-height: 1.75;

            .awoods-commenter-avatar-preview
                width: 30px;
                height: 30px;

                img
                    width: 100%;
                    height: 100%;
                    
                    border-radius: 50%;
                    // border: 1px solid #f5f5f5;
                    // padding: 2px;

            input
                min-width: 160px;
                flex-grow: 1;
                border-radius: 0px;

                &:focus
                    border-bottom: 1px solid #cacaca;

        .awoods-toolbar
            position: absolute;
            left: 15px;
            right: 15px;
            bottom: 15px;
            display: flex;
            flex-direction: row;
            // justify-content: flex-end;
            
            .awoods-toolbar-left
                display: flex;
                flex-direction: row;
                justify-content: flex-end;

                &>div:not(:last-child)
                    margin-right: 6px;

            .awoods-toolbar-right
                display: flex;
                flex-direction: row;
                justify-content: flex-end;
                margin: 0 0 0 auto

                &>div:not(:last-child)
                    margin-right: 6px;


        .awoods-tool-panel
            padding: 0px 8px;
            border: 1px solid #efefef;
            border-radius: 4px;

            &:first-child
                margin-top: 10px;

            &:not(:last-child)
                margin-bottom: 10px;

        .awoods-preview-panel
            @extend .awoods-tool-panel;

            .awoods-markdown
                @extend $awoods-markdown;

        .awoods-alert-info
            @extend $awoods-text;

            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            display: flex;
            align-items: center;
            flex-direction: column;
            background-color: #4d4d4dc2;
            overflow: auto;

            .awoods-alert-ops
                button
                    margin: 0 8px;

            .awoods-h
                display: flex;
                align-items: center;
                flex-direction: column;
                margin: auto 0px;

                .awoods-text
                    font-size: 1.3rem;
                    margin-bottom: 1rem;
                    text-align: center;

            *
                color: #ece9e7 !important;


        .awoods-submiting-indicator
            text-align: center;

            &:before
                content: "";
                display: inline-block;
                width: 15px;
                height: 15px;
                border: 3px solid #a0a0a0;
                border-top-color: transparent;
                border-bottom-color: transparent;
                border-radius: 50%;
                animation: spin 2s infinite linear;

            @keyframes spin
           
                from { transform: rotate(0deg); }
                to { transform: rotate(1turn); }

    // 输入框
    #awoods-input
        width: 100%;
        min-height: 10em;
        font-size: 0.875em;
        margin-top: 0.5rem;
        background: transparent;
        resize: vertical;
        transition: border-color 0.7s ease;
        border: 1px solid #50505017;
        word-break: break-all;
        border-radius: 4px;
        border-bottom-right-radius: 8px;

        &:focus, &:hover, &:focus
            border: 1px solid #86bb9d;

</style>